import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

import {
  SPINNER_ARC_LENGTH,
  SPINNER_DASH_GAP,
  SPINNER_ROTATION_DURATION,
} from 'ui/spinner/spinner.constants';

export const StyledSpinner = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.grey[800],
  [`&.${circularProgressClasses.indeterminate}`]: {
    animationDuration: SPINNER_ROTATION_DURATION,
  },
  [`& .${circularProgressClasses.circleDisableShrink}`]: {
    strokeDasharray: `${SPINNER_ARC_LENGTH}px, ${SPINNER_DASH_GAP}px`,
  },
}));
